import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaCalendarDay, 
  FaShieldHeart, 
  FaHandHoldingHeart, 
  FaAward, 
  FaHeart, 
  FaBriefcaseMedical, 
  FaPeopleRoof, 
  FaWhatsapp, 
  FaArrowRightToBracket, 
  FaIndustry,
  FaQuestion,
  FaHeartCircleCheck
} from "react-icons/fa6";
import { motion } from "framer-motion";
import BlobImage from '../components/BlobImage';
import { contactInfo } from '../constants';
import portrait from "../img/em-a.jpg"
import './Home.css';

const Home: React.FC = () => {
  return (
    <motion.div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title fade-in-up">
                Un espacio para reconectar
              </h1>
              <p className="hero-subtitle fade-in-up">
                Combino pasión con profesionalismo para impulsar el cambio en mis pacientes.
              </p>
              <div className="hero-buttons fade-in-up">
                <Link to="/contact#contact-form" className="btn btn-primary">
                  <FaQuestion className='icon'/> Solicitar Información
                </Link>
                <a
                  href={`https://wa.me/${contactInfo.completePhone}?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20cita`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-whatsapp"
                >
                  <FaWhatsapp className="icon" />
                  Escríbeme por WhatsApp
                </a>
              </div>
            </div>
            <div className="hero-image">
              <BlobImage
                src={portrait}
                imageHeight={210}
                d="M33.1,-56.7C44.8,-50.5,57.6,-45.6,63.3,-36.4C69,-27.1,67.6,-13.6,69.4,1C71.2,15.6,76.1,31.2,73,44.8C69.8,58.4,58.4,70,44.9,77.9C31.4,85.9,15.7,90.3,1.2,88.2C-13.2,86,-26.4,77.3,-39.4,69C-52.4,60.7,-65.3,52.9,-71,41.5C-76.7,30.1,-75.3,15,-73.9,0.8C-72.6,-13.5,-71.3,-26.9,-64.8,-37.1C-58.4,-47.2,-46.7,-54,-35.1,-60.2C-23.4,-66.5,-11.7,-72.1,-0.5,-71.2C10.7,-70.3,21.3,-62.8,33.1,-56.7Z"
              />
              <span className="blob-caption"> Hola, soy<br>
              </br> Emily!</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section section-light">
        <div className="container">
          <div className="section-header text-center">
            <h2>Mis Servicios</h2>
            <p className="section-subtitle">
              Ofrezco una atención personalizada y profesional para diferentes áreas de la psicología
            </p>
          </div>
          <div className="grid grid-3">
            <div className="card">
              <FaHeart className="service-icon" size={48} />
              <h3>Psicoterapia Individual</h3>
              <p>
                Tratamiento personalizado para ansiedad, depresión, estrés y otros
                trastornos emocionales con técnicas basadas en evidencia científica.
              </p>
              <Link to="/services" className="btn btn-primary">
                <FaArrowRightToBracket className="icon" /> Saber más...
              </Link>
            </div>
            <div className="card">
              <FaPeopleRoof className="service-icon" size={48} />
              <h3>Terapia Integral de Pareja </h3>
              <p>
                Ayudo a las parejas a mejorar su comunicación, resolver conflictos y fortalecer su relación
                a través de terapia especializada.
              </p>
              <Link to="/services" className="btn btn-primary">
                <FaArrowRightToBracket className="icon" /> Saber más...
              </Link>
            </div>
            <div className="card">
              <FaBriefcaseMedical className="service-icon" size={48} />
              <h3>Primeros Auxilios Psicológicos </h3>
              <p>
                Intervención breve y estructurada para quienes acaban de vivir
                un evento estresante o crítico (accidentes, pérdidas, crisis de pánico, etc.).
              </p>
              <Link to="/services" className="btn btn-primary">
                <FaArrowRightToBracket className="icon" /> Saber más...
              </Link>
            </div>
            <div className="card">
              <FaIndustry  className="service-icon" size={48} />
              <h3>Servicios Empresariales</h3>
              <p>
                Consultorías, charlas, talleres que buscan el mejorar el rendimiento en la empresa, mediante el desarrollo integral de los colaboradores y equipos de trabajo.

              </p>
              <Link to="/services" className="btn btn-primary">
                <FaArrowRightToBracket className="icon" /> Saber más...
              </Link>
            </div>
          </div>
          <div className="text-center mt-3">
            <Link to="/services" className="btn btn-secondary">
              ¿Qué mas servicios ofrezco?
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Me */}
      <section className="section section-dark">
        <div className="container">
          <div className="section-header text-center">
            <h2>¿Por qué elegirme?</h2>
            <p className="section-subtitle">
              Mi compromiso es brindarte la mejor atención psicológica con un enfoque humano y profesional
            </p>
          </div>
          <div className="grid grid-2">
            <div className="feature-card">
              <FaAward className="feature-icon" />
              <div className="feature-content">
                <h3>Experiencia Profesional</h3>
                <p>
                  Sólida experiencia y amplia formación en psicología clínica con formación
                  continua en las técnicas más actuales y efectivas.
                </p>
              </div>
            </div>
            <div className="feature-card">
              <FaShieldHeart className="feature-icon" />
              <div className="feature-content">
                <h3>Confidencialidad Total</h3>
                <p>
                  Tu privacidad está garantizada. Trabajo bajo estrictos códigos
                  de ética profesional y confidencialidad absoluta.
                </p>
              </div>
            </div>
            <div className="feature-card">
              <FaCalendarDay className="feature-icon" />
              <div className="feature-content">
                <h3>Diversos Horarios Flexibles</h3>
                <p>
                  Ofrezco horarios adaptados a tus necesidades, incluyendo sesiones
                  de mañana, tarde y consultas online.
                </p>
              </div>
            </div>
            <div className="feature-card">
              <FaHandHoldingHeart className="feature-icon" />
              <div className="feature-content">
                <h3>Atención Personalizada</h3>
                <p>
                  Cada persona es única. Adapto mi metodología a tus necesidades
                  específicas para lograr los mejores resultados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials 
      <section className="section section-light">
        <div className="container">
          <div className="section-header text-center">
            <h2>Lo que dicen mis pacientes</h2>
            <p className="section-subtitle">
              La satisfacción de mis pacientes es mi mayor recompensa
            </p>
          </div>
          <div className="grid grid-2">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "Em me ayudó a superar mi ansiedad de una manera
                  que nunca pensé posible. Su enfoque profesional y humano
                  marcó la diferencia en mi vida."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Ana M.</strong>
                <span>Terapia Individual</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "Gracias a la terapia de pareja, mi esposo y yo logramos
                  resolver nuestros problemas de comunicación. Estamos muy
                  agradecidos por su ayuda profesional."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Carlos y Laura</strong>
                <span>Terapia de Pareja</span>
              </div>
            </div>
          </div>
        </div>
      </section>*/}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>¿Listo para dar el primer paso?</h2>
            <p>
              No esperes más para cuidar tu bienestar emocional.
              Contáctame hoy y comencemos juntos este camino hacia una vida más plena.
            </p>
            <div className="cta-buttons fade-in-up">
              <Link to={"/services#first-step"} className="btn btn-primary" preventScrollReset>
                <FaHeartCircleCheck className="icon" />
                ¡Estoy Listo!
              </Link>
              <a
                href={`https://wa.me/${contactInfo.completePhone}?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20cita`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp"
              >
                <FaWhatsapp className="icon" />
                Escríbeme por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Home;